import { getDeviceInfo } from '@sitebase/device-detector';
export var byDeviceFactory = function (_a) {
    var supportedDevices = _a.supportedDevices;
    return function () {
        var deviceInfo = getDeviceInfo().info;
        // tslint:disable-next-line:prefer-for-of increment-decrement
        for (var i = 0; i < supportedDevices.length; i++) {
            var device = supportedDevices[i];
            var validator = validators[device];
            if (typeof validator !== 'function') {
                throw new Error("Got unknown device type in configuration: \"" + device + "\". Supported are: \"mobileWeb\", \"mobileNative\", \"desktop\"");
            }
            if (validator(deviceInfo)) {
                return true;
            }
        }
        return false;
    };
};
var validators = {
    mobileWeb: function (deviceInfo) {
        return deviceInfo.os !== 'desktop' && !deviceInfo.native;
    },
    desktop: function (deviceInfo) {
        return deviceInfo.os === 'desktop';
    },
    mobileNative: function (deviceInfo) {
        return deviceInfo.native;
    },
};
//# sourceMappingURL=byDevice.js.map